import axios from "axios";

import { routes } from "../../constants";
import { tableTokenConfig } from "./tableTokenConfig";

/**
 * Name (or replace) the guest on one seat.
 * `guest` is camelCase: { firstName, lastName, mobileNumber, gender, email }.
 */
const assignSeat = async (code, position, guest, token = null) => {
  const response = await axios.patch(
    routes.tableSeat(code, position),
    guest,
    tableTokenConfig(token)
  );
  return response;
};
export default assignSeat;
